// extracted by mini-css-extract-plugin
export default {"viewProductsButton":"ViewProductsButton_viewProductsButton__6gsQT"};